export const SITE_CONFIG = {
  baseUrl: "https://cyscom.eu",
  siteName: "CYSCOM",
  companyName: "Cyscom B.V.",
  tagline: "Official Stormshield distributor for Benelux",
  phone: "+31 6 309228 42",
  email: "info@cyscom.nl",
  address: {
    street: "Middenweg 15 A",
    postalCode: "9645 BA",
    city: "Veendam",
    country: "Nederland"
  }
} as const;

// Republish trigger: 2026-01-30
